import React, { useEffect, useState } from 'react';
import UniDropAdv from './UniDrop/UniDropAdv';
import { Col, Form, Input, Row } from 'antd';
import ZenFormInput from '../../pages/InputCreater/ZenFormInput';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const MultiDropdownTree = ({
    form,
    extraData,
    data,
    LocalDict,
    urlData,
    elements
}) => {
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [dropdownList, setDropdownList] = useState(data.dropDownList);
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];

    // const showNextDropdown = (index, value) => {
    //     let _dropdownList = [...dropdownList];
    //     _dropdownList.forEach((x, i) => {
    //         if (i > index) {
    //             x.visible = false;
    //             form.setFieldValue(x.data_index, '');
    //             form.setFieldValue(x.p_data_index, '');
    //         }
    //     });
    //     setDropdownList(_dropdownList);
    //     setTimeout(() => {
    //         _dropdownList.forEach((x, i) => {
    //             if ((index + 1) === i) {
    //                 x.visible = true;
    //                 x.sourceParams = { ...x.sourceParams, [dropdownList[index].data_index]: value }
    //             }
    //         });
    //         console.log(_dropdownList);
    //         setDropdownList(_dropdownList);
    //     }, 2000);
    // }

    const showNextDropdown = ({ index, e, value, args }) => {
        if (dropdownList[index].listTer?.includes(value)) return;
        let _dropdownList = dropdownList.map((dropdown, i) => {
            if (i > index) {
                return {
                    ...dropdown,
                    visible: false
                };
            }
            return dropdown;
        });

        setDropdownList(_dropdownList);

        _dropdownList.forEach((x, i) => {
            if (i > index) {
                form.setFieldsValue({ [x.data_index]: '' });
                form.setFieldsValue({ [x.p_data_index]: '' });
            }
        });

        setTimeout(() => {
            let values = {};
            setDropdownList(prevDropdownList => {
                let params = { ...args?.params };
                let updatedDropdownList = prevDropdownList.map((dropdown, i) => {
                    if (i < index) {
                        values[dropdown.data_index] = form.getFieldValue(dropdown.data_index);
                        params = { ...params, ...dropdown.dParams };
                    }
                    if ((index + 1) === i) {
                        // if (prevDropdownList[index].listTerminate?.includes(value)) {
                        //     return dropdown;
                        // }
                        return {
                            ...dropdown,
                            visible: true,
                            dParams: { ...args?.params, [dropdownList[index].data_index]: value },
                            sourceParams: { ...searchParams, ...params, ...dropdown.sourceParams, ...values, [dropdownList[index].data_index]: value }
                        };
                    }
                    return dropdown;
                });
                return updatedDropdownList;
            });
        }, 500);
    }


    const computeSourceParams = (list, i, base = {}) => {
        let merged = { ...base };
        for (let k = 0; k < i; k++) {
            const d = list[k];
            merged = {
                ...merged,
                ...d.sourceParams,
                [d.data_index]: d.default
            };
        }
        const curr = list[i];
        return {
            ...merged,
            ...curr.sourceParams,
            [curr.data_index]: curr.default
        };
    };


    return (
        <Row>
            {
                dropdownList.map((x, i) => {
                    if (dtArray.includes(x["typ"])) {

                        LocalDict[x["data_index"]] = x["format"]
                            ? x["format"]
                            : "YYYY-MM-DD hh:mm:ss";
                        LocalDict["data_index_from"] = x["data_index_from"];
                        LocalDict["data_index_to"] = x["data_index_to"];
                    }
                    const mergedSourceParams = x.visible
                        ? computeSourceParams(dropdownList, i, searchParams) // include base like searchParams if needed
                        : x.sourceParams;
                    return (
                        x.visible ?
                            <Col span={x.colSize} key={`multiLevelD-${i}`}>
                                <ZenFormInput
                                    urlData={{ ...urlData }}
                                    onChange={(e, value, args) => showNextDropdown({ index: i, e, value, args })}
                                    childType={x.childType}
                                    pageType={"zenForm"}
                                    header={x.header}
                                    footer={x.footer}
                                    labelColSpan={x["labelColSpan"]}
                                    style={x['style']}
                                    height={x['height']}
                                    layoutPosition="space-between"
                                    form={form}
                                    LocalDict={LocalDict}
                                    rows={x.rows}
                                    colSpan={24}
                                    name={x["data_index"]}
                                    label={x["label"]}
                                    defaultValue={x["default"]}
                                    typ={x["typ"]}
                                    disabled={x["readOnly"]}
                                    source={x["source"]}
                                    sourceParams={mergedSourceParams}
                                    auxParams={x["auxParams"]}
                                    format={x["format"]}
                                    errorMessage={x["errorMessage"]}
                                    placeHolder={x["placeHolder"]}
                                    required={x["required"]}
                                    options={x["data"]}
                                    from={x["x_index_from"]}
                                    to={x["x_index_to"]}
                                    url={x["url"]}
                                    includeAll={x["includeAll"]}
                                    pname={x["p_data_index"]}
                                    defaultFrom={x["defaultFrom"]}
                                    defaultTo={x["defaultTo"]}
                                    multiSelect={x["multiSelect"]}
                                    searchable={x["isSearchable"]}
                                    data={x}
                                    extraData={extraData}
                                    children={x['children']}
                                />
                                {
                                    x.hasCommentBox &&
                                    <Form.Item wrapperCol={24} name={`cmt_${x.data_index}`}>
                                        <Input placeholder='Enter Comment' />
                                    </Form.Item>
                                }
                            </Col>
                            // <Col span={24}>
                            //     <UniDropAdv

                            //         onChange={(e, value, args) => showNextDropdown({ index: i, e, value, args })}
                            //         labelCol={x.labelColSpan ? x.labelColSpan : 8}
                            //         bg="transparent"
                            //         form={form}
                            //         colSpan={x.colSize || 24}
                            //         multiSelect={x.multiSelect}
                            //         url={
                            //             x.url
                            //                 ? x.url
                            //                 : x.source === "mdict"
                            //                     ? "/mdict"
                            //                     : x.source === "usergroup"
                            //                         ? "/usergroup"
                            //                         : x.source === "cropdown"
                            //                             ? "/cropdown"
                            //                             : x.source === "dynamic"
                            //                                 ? "/dynamicDropdown"
                            //                                 : ""
                            //         }
                            //         disabled={x.disabled}
                            //         source={x.source}
                            //         options={x.data}
                            //         extraData={extraData}
                            //         urlData={x.sourceParams ? x.sourceParams : {}}
                            //         pname={x.p_data_index ? x.p_data_index : `p_${x.name}`}
                            //         name={x.data_index}
                            //         label={x.label}
                            //         errorMessage={x.errorMessage || "Please Select " + x.label}
                            //         required={x.required}
                            //         placeholder={x.placeHolder}
                            //         defaultValue={x.default ? x.default : null}
                            //         includeAll={x.includeAll ? x.includeAll : false}
                            //         searchable={x.isSearchable ? x.isSearchable : false}
                            //     />
                            // </Col>
                            : <></>
                    )
                })
            }
        </Row>
    )
};

export default MultiDropdownTree;